import $ from 'domtastic';
import { events } from '../utils';

class Select {
  constructor(elements) {
    this.elements = elements;
    this.config = elements.config;
    this.cacheDom();
    this.setInitialState(this.config.initialValue);
    this.bindEvents();
  }

  cacheDom() {
    this.$source = $((this.elements && this.elements.source) || '.js-select-source');
    this.$caption = $((this.elements && this.elements.caption) || '.js-select-caption');
  }

  bindEvents() {
    this.$source.on('change', (event) => {
      if (event.target.value === undefined) return;
      this.updateCaption(event.target.value);
      events.emit('reload', { type: this.config.type });
    });
  }

  updateCaption(value) {
    const $option = this.$source.find(`[value='${value}']`);
    if (!$option[0]) return;
    const text = $option.text() || '';
    events.emit('select', { value, type: this.config.type });
    this.$caption.attr('data-value', value)
      .text(text);
    this.setSelected(value);
  }

  setSelected(value) {
    const selected = this.$source.find('[selected]');
    selected.forEach(option => $(option).removeAttr('selected'));
    const option = this.$source.find(`[value='${value}']`);
    if (option) option.attr('selected', '');
  }

  setInitialState(value) {
    this.setSelected(value);
    this.updateCaption(value);
    this.$source.val(value);
    this.$caption.removeClass('-hidden');
  }
}

export default Select;



// WEBPACK FOOTER //
// ./components/Select.js